import { createSlice } from '@reduxjs/toolkit';
import firebase from 'firebase/app';
import "firebase/database";
import "firebase/storage";
import { dispatch } from '../store';

const initialState = {
	isLoading: false,
	error: false,
	mensagens: null,
};

const slice = createSlice({
	name: 'mensagens',
	initialState,
	reducers: {
		startLoading(state) {
			state.isLoading = true;
		},
		hasError(state, action) {
			state.isLoading = false;
			state.error = action.payload;
		},
		getMensagensSuccess(state, action) {
			state.isLoading = false;
			state.mensagens = action.payload;
		},
	}
});

export default slice.reducer;

export function getMensagens(pedidoId, requisicao) {
	return async () => {
		try {
			const mensagemRef = firebase.database().ref(`mensagens/${pedidoId}/${requisicao}`);
			dispatch(slice.actions.startLoading());
			mensagemRef.on('value', (snapshot) => {
				let data = snapshot.val();
				if (snapshot.val()) {
					data = Object.values(data);
					dispatch(slice.actions.getMensagensSuccess(data));
				} else {
					dispatch(slice.actions.getMensagensSuccess(null));
				}
			});
		} catch (error) {
			dispatch(slice.actions.hasError(error));
		}
	};
}

export function onSendMensagem(mensagemEnviada, pedidoId, requisicao) {
	return async () => {
		const { data, origem, mensagem, nome } = mensagemEnviada;

		const novaMensagem = {
			origem,
			data,
			nome,
			mensagem,
		}

		const mensagensListRef = firebase.database().ref(`mensagens/${pedidoId}/${requisicao}`);
		const newMensagemRef = mensagensListRef.push();
		newMensagemRef.set(novaMensagem);
	}
}
